import { render, staticRenderFns } from "./fa_av.vue?vue&type=template&id=4473b57b&scoped=true&"
import script from "./fa_av.vue?vue&type=script&lang=js&"
export * from "./fa_av.vue?vue&type=script&lang=js&"
import style0 from "./fa_av.vue?vue&type=style&index=0&id=4473b57b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473b57b",
  null
  
)

export default component.exports